import React from 'react';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet';
import { AboutContainer, AboutHero, AboutContent, AboutSection, StatsGrid, StatItem, TeamGrid, TeamMember, teamData, companyStats } from './estilosAbout';



function About() {
  const fadeInUp = {
    initial: { opacity: 0, y: 60 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.6 }
  };

  return (
    <AboutContainer>
      <Helmet>
        <title>Conoce a Juanfra Hernández: creador de soluciones digitales personalizadas</title>
        <meta name="description" content="Más que diseño o programación: creo experiencias digitales con enfoque humano y técnico. Descubre quién está detrás de cada línea de código" />
        <link rel="canonical" href="https://juanfrahernandez.es/quienes-somos" />
      </Helmet>

      <AboutHero
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <video autoPlay muted loop playsInline>
          <source src="https://videos.pexels.com/video-files/853844/853844-hd_1920_1080_25fps.mp4" type="video/mp4" />
        </video>
        <motion.div {...fadeInUp}>
          <h1>Quiénes Somos</h1>
          <p>Pasión por lo digital, compromiso con cada proyecto</p>
        </motion.div>
      </AboutHero>

      <AboutContent>
        <AboutSection
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <h2>Te cuento un poco quien soy...</h2>
          <p>Todo comenzó hace más de 8 años, con una curiosidad insaciable por el mundo digital y una pasión por construir cosas que funcionen, que se vean bien y que dejen huella. Empecé desarrollando páginas web desde cero, picando código y aprendiendo a resolver problemas reales de empresas reales. No había un gran equipo, ni una agencia detrás. Solo ganas, café y muchas horas frente al editor.
              Con el tiempo, esa pasión se convirtió en profesión. Fui perfeccionando mis habilidades en desarrollo web, SEO y diseño, y entendí que el valor no está solo en saber hacerlo todo, sino en saber rodearte de los mejores. Así nació mi red de colaboradores: diseñadores gráficos con visión, programadores de apps que hacen magia, y expertos en automatizaciones con IA que llevan los proyectos al siguiente nivel.
              Hoy lidero cada proyecto de forma cercana y estratégica, con la convicción de que cada web, cada marca y cada aplicación que creamos tiene que tener propósito, carácter y resultados.
              No soy una gran agencia. Soy alguien que lleva años haciendo esto con cabeza, con corazón y con un equipo de confianza detrás cuando el reto lo merece.</p>
              <p>"Transformo ideas en experiencias digitales, con estrategia, diseño y tecnología que suman."</p>
        </AboutSection>

        <StatsGrid>
          {companyStats.map((stat, index) => (
            <StatItem
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.2 }}
            >
              <div className="number">{stat.number}</div>
              <div className="label">{stat.label}</div>
            </StatItem>
          ))}
        </StatsGrid>

        <AboutSection>
          <h2>Nuestro Equipo</h2>
          <TeamGrid>
            {teamData.map((member, index) => (
              <TeamMember
              key={member.id}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.2 }}
            >
              <div className="image-container">
                {member.website ? (
                  <a href={member.website} target="_blank" rel="noopener noreferrer">
                    <img src={member.image} alt={member.name} />
                  </a>
                ) : (
                  <img src={member.image} alt={member.name} />
                )}
              </div>
              <h3>{member.name}</h3>
              <div className="position">{member.position}</div>
              <p className="description">{member.description}</p>
            </TeamMember>
            ))}
          </TeamGrid>
        </AboutSection>
      </AboutContent>
    </AboutContainer>
  );
}

export default About;